import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import { Select } from 'antd'
import type { CustomCellEditorProps } from 'ag-grid-react'
import { useGridCellEditor } from 'ag-grid-react'
import './SelectCellEditor.css'

const PurposesCellEditor = memo(
  ({ value, onValueChange, stopEditing, cellStartedEdit }: CustomCellEditorProps<any, string[]>) => {
    const selectRef = useRef<any>(null)
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
      if (cellStartedEdit) {
        setTimeout(() => {
          selectRef.current?.focus()
          setIsOpen(true)
        }, 0)
      }
    }, [cellStartedEdit])

    const focusIn = useCallback(() => {
      setIsOpen(true)
      setTimeout(() => selectRef.current?.focus(), 0)
    }, [])

    const focusOut = useCallback(() => {
      setIsOpen(false)
    }, [])

    useGridCellEditor({ focusIn, focusOut })

    const handleChange = (newValue: string[]) => {
      onValueChange(newValue)
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation()
        setIsOpen(false)
        stopEditing(true)
      }
    }

    return (
      <Select
        ref={selectRef}
        mode="tags"
        maxTagCount="responsive"
        value={value ?? []}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        open={isOpen}
        onOpenChange={setIsOpen}
        className="select-cell-editor"
        style={{ width: '100%' }}
        showSearch
        optionFilterProp="children"
        getPopupContainer={() => document.body}
      >
        {(value ?? []).map((name: string) => (
          <Select.Option key={name} value={name}>
            {name}
          </Select.Option>
        ))}
      </Select>
    )
  }
)

PurposesCellEditor.displayName = 'PurposesCellEditor'

export default PurposesCellEditor
